import './CustomRadio.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

export interface CustomRadioProps {
  image?: {
    alt: string;
    title: string;
    url: string;
  };
  label: string;
  radio: b2x.RadioProps<string>;
  type: 'image' | 'text';
}

export const CustomRadio = ({ image, label, radio, type }: CustomRadioProps) => {
  return (
    <b2x.Div className="custom-radio">
      <b2x.Radio {...radio}>
        <div className={classnames({ 'with-image': type === 'image' }, { 'with-text': type === 'text' })}>
          {image?.url ? (
            <b2x.Image
              alt={image.alt}
              className="w-100 h-100"
              fluid
              src={{ xs: image.url }}
              style={{ objectFit: 'cover' }}
              title={image.title}
            />
          ) : (
            label
          )}
        </div>
      </b2x.Radio>
    </b2x.Div>
  );
};
